export default{
  'monetization_ltv_LTV': 'LTV', // 1
  'monetization_ltv_LTV_of_7/30/180_Days': '7/30/180天LTV($)', // 2
  'monetization_ltv_Average_7D_LTV': '7天平均LTV', // 3
  'monetization_ltv_Average_30D_LTV': '30天平均LTV', // 4
  'monetization_ltv_Average_180D_LTV': '180天平均LTV',
  'monetization_ltv_LTV_Tracking_for_Daily_Registered_Users': '每日新进用户的 LTV 追踪', // 5
  'monetization_ltv_Key_Days': '关键日', // 7
  'monetization_ltv_Date': '日期', // 8
  'monetization_ltv_Register_Users': '新进用户', // 9
  'monetization_ltv_': '1D LTV', // 1天LTV
  'monetization_ltv_7D_LTV': '7天 LTV', // 1天LTV
  'monetization_ltv_30D_LTV': '30天 LTV', // 1天LTV
  'monetization_ltv_180D_LTV': '180天 LTV', // 1天LTV
  'monetization_ltv_Register': '新进', //
  'monetization_ltv_D': '天', //
  'monetization_ltv_Revenue($)': '付费金额',
}
